import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const CTABand = () => {
  return (
    <section id="cta" className="relative py-20 md:py-28">
      <div className="squiggle-bg" />
      <div className="max-w-4xl mx-auto px-6 relative text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-[#143324]/20 bg-[#f5f1e6] text-[11px] tracking-[0.2em] uppercase text-[#143324] font-body mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-[#143324]" />
          Start Learning Today
        </div>
        <h2 className="font-serif-display text-[#143324] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
          Reach out for <em className="italic">Course</em> enquiries
        </h2>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <Link to="/contact" className="inline-flex items-center gap-2 btn-primary px-6 py-3 rounded-full text-sm font-body">
            Contact Us <ArrowUpRight size={16} />
          </Link>
          <Link to="/ea-course" className="inline-flex items-center gap-2 btn-outline px-6 py-3 rounded-full text-sm font-body">
            Explore Course
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTABand;
